/*  ========================================================================
    # Hooks - Use Translation
    ========================================================================  */

/**
 * How to use:
 * const __ = useTranslation();
 * __('TRANSLATION_STRING')
 *
 * @returns {function(): string}
 */
const useTranslation = (): ((key: string, replacements?: Record<string, string>) => string) => {
  return (key: string, replacements: Record<string, string> = {}): string => {
    let value
      = (window as Window & { translations?: Record<string, string> }).translations?.[key] || key;

    for (const [placeholder, replaceWith] of Object.entries(replacements)) {
      value = value.replaceAll(`{${placeholder}}`, replaceWith);
    }

    return value;
  };
};

export default useTranslation;
